module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('notifications', {
    attrs: {
      "show": ['all']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('div', {
    staticClass: "account-section-links"
  }, [_c('router-link', {
    staticClass: "acc-inner-link",
    attrs: {
      "to": {
        name: 'account.bookings'
      }
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_list_bookings))])])]), _vm._v(" "), _c('a', {
    staticClass: "acc-inner-link",
    on: {
      "click": _vm.newBooking
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_new_booking))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "acc-inner-link",
    attrs: {
      "to": {
        name: 'account.membership'
      }
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_c('i', {
    staticClass: "fa fa-credit-card-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_membership_card))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "acc-inner-link",
    attrs: {
      "to": {
        name: 'account.payments'
      }
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_c('i', {
    staticClass: "fa fa-gbp"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_list_payments))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "acc-inner-link",
    attrs: {
      "to": {
        name: 'account.children'
      }
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_c('i', {
    staticClass: "fa fa-child"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_list_children))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "acc-inner-link",
    attrs: {
      "to": {
        name: 'account.details'
      }
    }
  }, [_c('div', {
    staticClass: "vhboth"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.locale.button_update_account_details))])])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa fa-ticket"
  }, [_c('span', {
    staticClass: "fa fa-plus"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-491730f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Overview.vue
// module id = 173
// module chunks = 0